import styled from 'styled-components';

import { Box } from 'styles/box';

export const Wrapper = styled.div<{ loading?: boolean }>`
  padding: 32px 32px 64px;
  opacity: ${({ loading }) => (loading ? 0.6 : 1)};
`;

export const ReleaseWrapper = styled(Box)`
  background-color: var(--colorWhite);
  border-radius: 8px;
  border: 1px solid var(--colorBlueGray200);
`;

export const DeleteWrapper = styled(Box)`
  cursor: pointer;
`;
export const TabsWrapper = styled.div`
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: var(--colorWhite);
  overflow: hidden;
  border-top: 1px solid var(--colorBlueGray200);
  border-left: 1px solid var(--colorBlueGray200);
  border-right: 1px solid var(--colorBlueGray200);
  border-bottom: none;
`;

export const ScrollableBox = styled(Box)`
  max-height: 70vh;
  overflow-y: auto;
`;

export const ReleaseNoteWrapper = styled(Box)`
  background-color: var(--colorBlueGray50);
  border-radius: 8px;
  border: 1px solid var(--colorBlueGray200);
  width: calc(100% - 16px);
`;
